import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewAssetModalPage } from './view-asset-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ViewAssetModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewAssetModalPage]
})
export class ViewAssetModalPageModule {}
